<template>
    <div class="zebra-crossing-detail">
        <el-form :model="detail">
            <div class="zebra-item">
                <div class="zebra-item_tit">申请登记单</div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="编号：">{{ detail.serial_number  }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="状态：">{{ status }}</el-form-item>
                    </el-col>

                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="所在位置：">{{ detail.location | getCname( locationList)}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="申请人：">{{ detail.applicant.name }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="使用人：">{{ detail.user.name }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="当前处理人：">{{ detail.current_handler.name }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="服务组：">{{ detail.current_department }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="参与处理的人员：">
                            <span v-for="item in detail.participant">{{item}} * </span>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="是否项目：">{{detail.is_project?'是':'否'}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="项目名称：">{{ detail.project_name|getCname(projectName)  }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="资源类型：">{{ detail.resource_alias }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="资源数量：">{{ detail.resource_count }}</el-form-item>
                    </el-col>
                </el-row>

<!--                <el-row v-for="index in Math.ceil(attrData.length/2)">-->
<!--                    <el-col :span="12">-->
<!--                        <el-form-item-->
<!--                            v-if="attrData[(index-1)*2]['value_type'] === 'v_list'"-->
<!--                            :label="attrData[(index-1)*2]['alias']+':'">-->
<!--                            {{  detail.specification[attrData[(index-1)*2]['name']].join(',') }}-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            v-else-if="attrData[(index-1)*2]['value_type'] === 'v_int'"-->
<!--                            :label="attrData[(index-1)*2]['alias']+':'">-->
<!--                            {{  detail.specification[attrData[(index-1)*2]['name']] }}-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            v-else-if="attrData[(index-1)*2]['value_type'] === 'v_str'"-->
<!--                            :label="attrData[(index-1)*2]['alias']+':'">-->
<!--                            {{  detail.specification[attrData[(index-1)*2]['name']] }}-->
<!--                        </el-form-item>-->
<!--                        <el-form-item v-else-->
<!--                            :label="attrData[(index-1)*2]['alias']+':'">-->
<!--                            {{  detail.specification[attrData[(index-1)*2]['name']] | getCname(dictionary[attrData[(index-1)*2]['name']]) }}-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
<!--                    <el-col :span="12">-->
<!--                        <el-form-item-->
<!--                            v-if="attrData[index+(index-1)]['value_type'] === 'v_list'"-->
<!--                            :label="attrData[index+(index-1)]['alias']+':'">-->
<!--                            {{ detail.specification[attrData[index+(index-1)]['name']].join(',') }}-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            v-else-if="attrData[index+(index-1)]['value_type'] === 'v_int'"-->
<!--                            :label="attrData[index+(index-1)]['alias']+':'">-->
<!--                            {{ detail.specification[attrData[index+(index-1)]['name']] }}-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            v-else-if="attrData[index+(index-1)]['value_type'] === 'v_str'"-->
<!--                            :label="attrData[index+(index-1)]['alias']+':'">-->
<!--                            {{ detail.specification[attrData[index+(index-1)]['name']] }}-->
<!--                        </el-form-item>-->
<!--                        <el-form-item v-else-->
<!--                            :label="attrData[index+(index-1)]['alias']+':'">-->
<!--                            {{ detail.specification[attrData[index+(index-1)]['name']] | getCname(dictionary[attrData[index+(index-1)]['name']]) }}-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
<!--                </el-row>-->

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="创建时间：">{{ detail.create_time }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="计划完成时间：">{{ detail.end_time }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="关闭时间：">{{ detail.close_time }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="更新时间：">{{ detail.update_time }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item  label="用途：" >{{detail.purpose}}</el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form-item  label="备注：" >{{detail.comment}}</el-form-item>
                    </el-col>
                </el-row>

            </div>
        </el-form>
    </div>
</template>

<script>
    import commonService from "../../../services/common.service"
    import services from "../resourceApply.service";
    export default {
        props:{
            detail:Object,
            companyList:Array,
            changeList:Array,
        },
        data() {
            return {
                // attrData:[],
                status:'',
            }
        },
        created() {
            // console.log(this.changeList,'表单明细-变更分类');
            // console.log(this.companyList,'表单明细-公司列表');
        },
        watch:{

            detail:{
                handler(newval,oldval){

                    if(newval && newval.resource_type){
                        this.status=this.getNameById(newval.status,this.resourceStatus)

                    }
                },
                immediate:true,
                deep:true
            }
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            locationList(){
                return this.dictionary.location;
            },
            //项目名称
            projectName(){
                return this.dictionary.project_name
            },
            //状态
            resourceStatus(){
                return this.dictionary.resource_application_status
            },
            // attrData(){
            //     return this.$store.state.resourceTypeAttr
            // }
        },
        methods: {

        }
    }
</script>

<style scoped>
    .zebra-crossing-detail .zebra-item .el-form-item__content a{
        float: left;
        margin-left: 20px;
    }
    .preview{
        color:blue;
        cursor: pointer;
        margin-left: 10px;
    }
</style>
